import React from "react";
import PropTypes from 'prop-types';

export default function BlogPostTextBlock(
    {
        html
    }) {

    let correctedHtml = html.replace(/https?:\/\/www.theinformationlab.co.uk\/wp\content\/uploads/g,'https://content.theinformationlab.co.uk/images');
    correctedHtml = correctedHtml.replace(/\/wp\content\/uploads/g,'https://content.theinformationlab.co.uk/images');
    return (
        <div className="my-5 text-[15px] font-light" dangerouslySetInnerHTML={{__html: correctedHtml}}></div>
    )
}

BlogPostTextBlock.propTypes = {
    html: PropTypes.string.isRequired
}